import styled, {css} from 'styled-components'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {DialogHeader} from '@/components/ui/dialog-atoms/DialogAtoms'
import {GalleryImageItem} from '@/components/commons/gallery-image-item/GalleryImageItem'

export const StyledDialogHeader = styled(DialogHeader)`
    position: relative;
`

export const StyledDialogHeaderTitle = styled(Flexbox)(
    ({theme: {typography}}) => css`
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        & span {
            ${typography.textXs};
        }
    `
)

export const StyledGalleryImageItem = styled(GalleryImageItem)`
    height: 100%;
`
